// extracted by mini-css-extract-plugin
module.exports = {"container":"modal_container__V7apq","qr":"modal_qr__zjxw-","s":"modal_s__1lQLx","error":"modal_error__2B32p","preloader":"modal_preloader__35IHc"};